import { gql } from "apollo-boost";

export const GET_FEATURED_OFFERS = gql`
  query consumerGetFeaturedOffers($ids: [ID!]!) {
    consumerGetFeaturedOffers(ids: $ids) {
      id
      name
      code
      discountValueType
      discountValue
      maxDiscountCap
    }
  }
`;
